/* eslint-disable array-callback-return */
import React, { useState } from "react";
import { Modal, ModalBody, ModalHeader, Col, Row, Button } from "reactstrap";
//redux
import { connect } from "react-redux";
// alerta
import SweetAlert from "react-bootstrap-sweetalert";
// select
import Select from "react-select";
// query
import { useMutation } from "react-query";
//services
import { updateFlight } from "../../../utils/services/flight";
// componentes
import ButtonSpinner from "../../../components/Buttons/ButtonSpinner";

function Editlight(props) {
  const { isOpen, toggle } = props;
  const [modalBackdrop, setModalBackdrop] = useState(false);
  //state de participantes
  const [participantSelected, setParticipantSelected] = useState();
  //confirmção de criação
  const [success_dlg, setsuccess_dlg] = useState(false);
  //state dos campos obrigatórios
  const [companyError, setCompanyError] = useState("");
  const [sourcerError, setSourceError] = useState("");
  const [destinyError, setDestinyError] = useState("");
  const [dateBoardingError, setDateBoardingError] = useState("");
  const [timeBoardingError, setTimeBoardingError] = useState("");
  const [dateArrivalError, setDateArrivalError] = useState("");
  const [timeArrivalError, setTimeArrivalError] = useState("");
  const [isLoading, setIsloading] = useState(false);
  const [dateBoarding, setDateBoarding] = useState("");

  function toggleBackdrop() {
    setModalBackdrop(!modalBackdrop);
  }
  function checkDateTimeInterval(e) {
    const isValidDate = (d) => d && d !== "";
    const isValidTime = (t) => t && t !== "";

    const dateStart = e.target[2].value;
    const dateEnd = e.target[4].value;
    const hourStart = e.target[3].value;
    const hourEnd = e.target[5].value;

    const hasStartDate = isValidDate(dateStart);
    const hasEndDate = isValidDate(dateEnd);
    const hasStartHour = isValidTime(hourStart);
    const hasEndHour = isValidTime(hourEnd);

    const startDateTime =
      hasStartDate && hasStartHour
        ? new Date(`${dateStart}T${hourStart}`)
        : null;

    const endDateTime =
      hasEndDate && hasEndHour ? new Date(`${dateEnd}T${hourEnd}`) : null;

    if (startDateTime && endDateTime && endDateTime >= startDateTime) {
      return true;
    }
    return false;
  }
  const clearErrors = () => {
    setDateBoardingError("");
    setTimeBoardingError("");
    setDateArrivalError("");
    setTimeArrivalError("");
    setDateArrivalError("");
    setCompanyError("");
    setSourceError("");
    setDestinyError("");
  };

  async function submitForm(e) {
    clearErrors();

    if (e.target[2].value === "") {
      setDateBoardingError("O campo Data embarque é obrigatório");
      return;
    } else setDateBoardingError("");

    if (e.target[3].value === "") {
      setTimeBoardingError("O campo Hora embarque é obrigatório");
      return;
    } else setTimeBoardingError("");

    if (e.target[4].value === "") {
      setDateArrivalError("O campo Data chegada é obrigatório");
      return;
    } else setDateArrivalError("");

    if (e.target[5].value === "") {
      setTimeArrivalError("O campo Hora chegada é obrigatório");
      return;
    } else setTimeArrivalError("");

    if (!checkDateTimeInterval(e)) {
      setDateArrivalError(
        "A Data e Hora chegada não pode ser menor que a Data e Hora embarque."
      );
      return;
    } else setDateArrivalError("");

    if (e.target[6].value === "") {
      setCompanyError("O campo Companhia é obrigatório");
      return;
    } else setCompanyError("");

    if (e.target[7].value === "") {
      setSourceError("O campo Origem é obrigatório");
      return;
    } else setSourceError("");

    if (e.target[8].value === "") {
      setDestinyError("O campo Destino é obrigatório");
      return;
    } else setDestinyError("");

    setIsloading(true);

    await updateFlight({
      event: props.idEvent,
      login: props.editFlight.login.id,
      boardingdate: e.target[2].value,
      boardingtill: e.target[3].value,
      arrivaldate: e.target[4].value,
      arrivaltime: e.target[5].value,
      company: e.target[6].value,
      origin: e.target[7].value,
      destination: e.target[8].value,
      locator: e.target[9].value,
      eticket: e.target[10].value,
      flightnumber: e.target[11].value,
      terminal: e.target[12].value,
      seat: e.target[13].value,
      boardinggroup: e.target[14].value,
      extrainformation: e.target[15].value,
      jwt: props.state.global_user_data.data.token,
      id: props.editFlight.id,
    }).then((res) => {
      setIsloading(false);
      const { message } = res;

      if (message === "updated") {
        props.data();
        setsuccess_dlg(true);
      }
    });
  }

  // const submitForm = useMutation(

  //   {
  //     onSuccess: (data) => {

  //     },

  //     onError: (error) => {
  //       console.log("erro", error)
  //       setIsloading(false);
  //     },
  //   }
  // );

  // async function getAllParticipants() {
  //   await getParticipants({
  //     jwt: props.state.global_user_data.data.token,
  //     idEvent: props.idEvent,
  //     offset: 1,
  //     limit: 0,
  //   })
  //     .then((response) => {
  //       setParticipants(response.data.data);
  //     })
  //     .catch((error) => {
  //       console.log("error", error);
  //     });
  // }

  return (
    <Modal
      isOpen={isOpen}
      toggle={() => {
        toggleBackdrop();
      }}
      autoFocus={true}
      centered={true}
    >
      {success_dlg ? (
        <SweetAlert
          success
          title={"Editado"}
          onConfirm={() => {
            toggle();
            setsuccess_dlg(false);
          }}
        >
          {"Voo editado com sucesso!"}
        </SweetAlert>
      ) : null}
      <ModalHeader toggle={toggle}>Editar Voo</ModalHeader>
      <ModalBody>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            submitForm(e);
          }}
        >
          <Row>
            <Col lg={12}>
              <div>
                <label className="form-label">ID do Voo</label>
                <input
                  className="form-control"
                  type="text"
                  defaultValue={props.editFlight.id}
                  disabled
                />
              </div>
            </Col>
          </Row>

          <Row style={{ marginTop: 20 }}>
            <Col lg={12}>
              <div>
                <label className="form-label">Participante</label>
                <input
                  className="form-control"
                  type="text"
                  defaultValue={props.editFlight.login.nome}
                  disabled
                />
              </div>
            </Col>
          </Row>

          <Row style={{ marginTop: 20 }}>
            <Col lg={6}>
              <div>
                <label className="form-label">Data embarque*</label>
                <input
                  className="form-control"
                  type="date"
                  // defaultValue="2019-08-19T13:45:00"
                  defaultValue={props.editFlight.boardingdate}
                  id="example-datetime-local-input"
                  onChange={({ target }) => setDateBoarding(target.value)}
                />
              </div>
              {dateBoardingError && (
                <a style={{ color: "red" }}>{dateBoardingError}</a>
              )}
            </Col>

            <Col lg={6}>
              <div>
                <label className="form-label">Hora embarque*</label>
                <input
                  className="form-control"
                  type="time"
                  // defaultValue="2019-08-19T13:45:00"
                  defaultValue={props.editFlight.boardingtill}
                  id="example-datetime-local-input"
                />
              </div>
              {timeBoardingError && (
                <a style={{ color: "red" }}>{timeBoardingError}</a>
              )}
            </Col>
          </Row>

          <Row style={{ marginTop: 20 }}>
            <Col lg={6}>
              <div>
                <label className="form-label">Data chegada*</label>
                <input
                  className="form-control"
                  type="date"
                  // defaultValue="2019-08-19T13:45:00"
                  defaultValue={props.editFlight.arrivaldate}
                  id="example-datetime-local-input"
                  min={dateBoarding || props.editFlight.boardingdate}
                />
              </div>
              {dateArrivalError && (
                <a style={{ color: "red" }}>{dateArrivalError}</a>
              )}
            </Col>

            <Col lg={6}>
              <div>
                <label className="form-label">Hora chegada*</label>
                <input
                  className="form-control"
                  type="time"
                  // defaultValue="2019-08-19T13:45:00"
                  defaultValue={props.editFlight.arrivaltime}
                  id="example-datetime-local-input"
                />
              </div>
              {timeArrivalError && (
                <a style={{ color: "red" }}>{timeArrivalError}</a>
              )}
            </Col>
          </Row>

          <Row style={{ marginTop: 20 }}>
            <Col lg={12}>
              <div>
                <label className="form-label">Companhia*</label>
                <input
                  className="form-control"
                  type="text"
                  defaultValue={props.editFlight.company}
                />
              </div>
              {companyError && <a style={{ color: "red" }}>{companyError}</a>}
            </Col>
          </Row>

          <Row style={{ marginTop: 20 }}>
            <Col lg={12}>
              <div>
                <label className="form-label">Origem*</label>
                <input
                  className="form-control"
                  type="text"
                  defaultValue={props.editFlight.origin}
                />
              </div>
              {sourcerError && <a style={{ color: "red" }}>{sourcerError}</a>}
            </Col>
          </Row>

          <Row style={{ marginTop: 20 }}>
            <Col lg={12}>
              <div>
                <label className="form-label">Destino*</label>
                <input
                  className="form-control"
                  type="text"
                  defaultValue={props.editFlight.destination}
                />
              </div>
              {destinyError && <p style={{ color: "red" }}>{destinyError}</p>}
            </Col>
          </Row>

          <Row style={{ marginTop: 20 }}>
            <Col lg={12}>
              <div>
                <label className="form-label">Localizador</label>
                <input
                  className="form-control"
                  type="text"
                  defaultValue={props.editFlight.locator}
                />
              </div>
            </Col>
          </Row>

          <Row style={{ marginTop: 20 }}>
            <Col lg={12}>
              <div>
                <label className="form-label">E-Ticket</label>
                <input
                  className="form-control"
                  type="text"
                  defaultValue={props.editFlight.eticket}
                />
              </div>
            </Col>
          </Row>

          <Row style={{ marginTop: 20 }}>
            <Col lg={12}>
              <div>
                <label className="form-label">Número do Voo</label>
                <input
                  className="form-control"
                  type="text"
                  defaultValue={props.editFlight.flightnumber}
                />
              </div>
            </Col>
          </Row>

          <Row style={{ marginTop: 20 }}>
            <Col lg={12}>
              <div>
                <label className="form-label">Terminal</label>
                <input
                  className="form-control"
                  type="text"
                  defaultValue={props.editFlight.terminal}
                />
              </div>
            </Col>
          </Row>

          <Row style={{ marginTop: 20 }}>
            <Col lg={12}>
              <div>
                <label className="form-label">Assento</label>
                <input
                  className="form-control"
                  type="text"
                  defaultValue={props.editFlight.seat}
                />
              </div>
            </Col>
          </Row>

          <Row style={{ marginTop: 20 }}>
            <Col lg={12}>
              <div>
                <label className="form-label">Grupo de embarque</label>
                <input
                  className="form-control"
                  type="text"
                  defaultValue={props.editFlight.boardinggroup}
                />
              </div>
            </Col>
          </Row>

          <Row style={{ marginTop: 20 }}>
            <Col lg={12}>
              <div>
                <label className="form-label">Informações extras</label>
                <input
                  className="form-control"
                  type="text"
                  defaultValue={props.editFlight.extrainformation}
                />
              </div>
            </Col>
          </Row>

          <Row>
            <Col
              md={12}
              style={{
                width: "100%",
                margin: "20px auto 0",
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <Button
                color="danger"
                className="btn waves-effect waves-light"
                style={{ width: 80 }}
                onClick={() => toggle()}
              >
                Fechar
              </Button>
              <ButtonSpinner
                isLoading={isLoading}
                title={"Salvar"}
                marginLeft={10}
                action="U"
              />
            </Col>
          </Row>
        </form>
      </ModalBody>
    </Modal>
  );
}

const mapStateToProps = function (state) {
  return { state: state };
};

export default connect(mapStateToProps)(Editlight);
